import { render } from "./FlyerProdutosCards.vue?vue&type=template&id=7f016217&scoped=true"
import script from "./FlyerProdutosCards.vue?vue&type=script&lang=js"
export * from "./FlyerProdutosCards.vue?vue&type=script&lang=js"

import "./FlyerProdutosCards.vue?vue&type=style&index=0&id=7f016217&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f016217"]])

export default __exports__